import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import queryString from 'query-string';

import { MirrorService } from 'services/MirrorService';

import { usePartnerOffer } from 'hooks/usePartnerOffer';
import { getUser } from 'store/auth/selectors';

import { usePartnerId } from './usePartnerId';

const UPGRADE_PAGE_URL = '/upgrade';

export const useUpgradePageTransition = () => {
  const history = useHistory();

  const user = useSelector(getUser);

  const { handleOpenPartnerOffer } = usePartnerOffer();
  const { isOrganicPartnerIdOnMainMirror } = usePartnerId();

  const isPartnerOfferEnabled = useMemo(
    () =>
      user?.is_buyer &&
      user?.has_premium_subscription &&
      !user?.is_premium &&
      !user?.is_vip &&
      !isOrganicPartnerIdOnMainMirror &&
      !MirrorService.isMidsOrDatesMe,
    [
      user?.has_premium_subscription,
      user?.is_buyer,
      user?.is_premium,
      user?.is_vip,
      isOrganicPartnerIdOnMainMirror,
    ]
  );

  const getResultUrl = (params?: string) => {
    const queries = params && queryString.parse(params);

    return queries
      ? `${UPGRADE_PAGE_URL}?${queryString.stringify(queries)}`
      : UPGRADE_PAGE_URL;
  };

  const handleSafePushUpgradePage = (params?: string, state?: any) => {
    if (isPartnerOfferEnabled) {
      handleOpenPartnerOffer();
    } else {
      history.push(getResultUrl(params), {
        ...(state && { ...state }),
      });
    }
  };

  const handleSafeReplaceUpgradePage = (params?: string) => {
    if (isPartnerOfferEnabled) {
      handleOpenPartnerOffer();
    } else {
      history.replace(getResultUrl(params));
    }
  };

  return {
    handleSafePushUpgradePage,
    handleSafeReplaceUpgradePage,
  };
};
